
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PinPage from './aa000/PinPage';
import SuccessPage from './aa000/SuccessPage';
import TermsConditionPage from './aa000/TermsConditionPage';

function App() 
{
  return (
    <Router>
      <Routes>
        <Route path="/iq/pin" element={<PinPage />} />
        <Route path="/terms" element={<TermsConditionPage />} />
        <Route path="/success" element={<SuccessPage />} />
      </Routes>
    </Router>
  );
}

export default App;